<template>
  <img
    class="h-12 w-auto"
    src="/images/login-logo.png"
    alt="Talk 360" />
</template>
